import { useSeo } from "../hooks/useSeo";
import Quiz from "../components/Quiz";

export default function QuizPage() {
  useSeo({
    title: "Melyik póthaj illik hozzád? Hajtípus kérdőív | Hair Elixir Hungary",
    description: "Válaszolj néhány kérdésre, és megmutatjuk, melyik európai vagy kazahsztáni póthaj illik legjobban a hajadhoz.",
    path: "/kerdoiv",
  });
  return (
    <main data-testid="page-quiz" className="pt-32 md:pt-32">
      <Quiz />
    </main>
  );
}
